import api from './axios';

// All routes are ADMIN-only on the backend (SecurityConfig locks /api/admin/analytics/**).

export const getMetadata = () => api.get('/admin/analytics/metadata');

export const listAlerts = () => api.get('/admin/analytics/alerts');

export const createAlert = (body) => api.post('/admin/analytics/alerts', body);

export const updateAlert = (id, body) => api.put(`/admin/analytics/alerts/${id}`, body);

export const setAlertEnabled = (id, enabled) =>
  api.patch(`/admin/analytics/alerts/${id}/enabled`, null, { params: { enabled } });

export const deleteAlert = (id) => api.delete(`/admin/analytics/alerts/${id}`);

/**
 * `start`/`end` are an optional inclusive date override used only for preview and manual sends —
 * scheduled runs always use the alert's own cadence.
 */
export const previewAlert = (id, start, end) =>
  api.get(`/admin/analytics/alerts/${id}/preview`, {
    params: { start: start || undefined, end: end || undefined },
    responseType: 'text',
  });

export const sendAlertNow = (id, start, end) =>
  api.post(`/admin/analytics/alerts/${id}/send`, null, {
    params: { start: start || undefined, end: end || undefined },
  });

export const listDispatches = (page = 0, size = 20) =>
  api.get('/admin/analytics/dispatches', { params: { page, size } });

/** Sends to the signed-in admin only — the backend ignores any recipient sent from here. */
export const sendTestReport = (period = 'WEEKLY') =>
  api.post('/admin/analytics/test-send', null, { params: { period } });
